import styled, { css } from "styled-components";

export const StyledTableContainer = styled.div`
    display: block;
    max-width: 100%;
    margin-bottom: 15px;
`;

export const StyledTableWrapper = styled.div`
    display: block;
    max-width: 100%;
`;

export const StyledThead = styled.thead`
    ${({ theme }) => theme.fonts.mulishRegular};
    font-size: 11px;
    line-height: 1.2em;
    letter-spacing: -0.025em;
    color: ${({ theme }) => theme.colors.darkGrey};
`;

export const StyledTbody = styled.tbody`
    ${({ theme }) => theme.fonts.mulishLight};
    font-size: 14px;
    line-height: 1.2em;
    letter-spacing: -0.025em;
    color: ${({ theme }) => theme.colors.darkGrey};
`;

export const StyledTfoot = styled.tfoot`
    ${({ theme }) => theme.fonts.mulishBold};
    font-size: 14px;
    line-height: 1.2em;
    letter-spacing: -0.025em;
    color: ${({ theme }) => theme.colors.darkGrey};
`;

export const StyledTr = styled.tr`
    border-bottom: 1px solid ${({ theme }) => theme.colors.mediumGrey};
`;

export const StyledTh = styled.th`
    padding: 18px 5px;
    vertical-align: middle;
    &:last-child {
        text-align: right;
    }
`;

export const StyledTd = styled.td`
    padding: 20px 5px;
    vertical-align: middle;
    &:last-child {
        text-align: right;
    }
`;

export const StyledTable = styled.table`
    width: 100%;
    text-align: left;
    ${({ guttersCell }) => guttersCell === 'small' && css`
        ${StyledTd} {
            padding: 16px 5px;
        };
    `};
    ${({ guttersCell }) => guttersCell === 'large' && css`
        ${StyledTd} {
            padding: 20px 5px;
        };
    `};
`;